import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AgeVerificationPolicy } from '../../legal/age-verification-policy/age-verification-policy';
import { CommunityGuidelines } from '../../legal/community-guidelines/community-guidelines';
import { CookiePolicy } from '../../legal/cookie-policy/cookie-policy';
import { PrivacyPolicy } from '../../legal/privacy-policy/privacy-policy';
import { TermsOfService } from '../../legal/terms-of-service/terms-of-service';

type LegalTabKey = 'terms' | 'privacy' | 'cookies' | 'community' | 'age-verification';

interface LegalTab {
  key: LegalTabKey;
  label: string;
}

@Component({
  selector: 'app-dashboard-legal',
  standalone: true,
  imports: [
    CommonModule,
    TermsOfService,
    PrivacyPolicy,
    CookiePolicy,
    CommunityGuidelines,
    AgeVerificationPolicy,
  ],
  templateUrl: './legal.html',
})
export class DashboardLegal {
  readonly tabs: LegalTab[] = [
    { key: 'terms', label: 'Terms of Service' },
    { key: 'privacy', label: 'Privacy Policy' },
    { key: 'cookies', label: 'Cookie Policy' },
    { key: 'community', label: 'Community Guidelines' },
    { key: 'age-verification', label: 'Age Verification' },
  ];

  activeTab: LegalTabKey = 'terms';

  setTab(key: LegalTabKey): void {
    this.activeTab = key;
  }
}
